import App from './App.svelte';
// add target=_self to all existing links before rendering the app
// so routify will ignore all links outside the app
document.addEventListener("DOMContentLoaded", () => {
    const anchorElements = document.querySelectorAll('a');
    anchorElements.forEach((a) => {
        if (!a.hasAttribute("target")) {
            a.setAttribute('target', "_self");
        }
    });
});
const app = new App({
    target: document.getElementById('dev') || document.body,
    props: {}
});
export default app;
